var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7ba972d9dafc82572ae753bccfb4e4e5.svg#p';
                    var viewUrl = 'sprites.7ba972d9dafc82572ae753bccfb4e4e5.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 461 589',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };